import { GridReducer } from '../../../common/grid/grid.reducer';
import {GridFilterReducer} from '../../../common/grid/filter/grid-filter.reducer';
import * as GRID from '../../../common/grid/grid.constants';
import * as FORM from '../../../common/form/input/input.constants';
import { TYPES } from './master-doc-list-action-type.constants';
import { IDS } from './master-doc-list-action-id.constants';
import merge from 'lodash/merge';
import get from 'lodash/get';
import set from 'lodash/set';
import {getDocFileNameFromPath} from "../../../common/utils/util.path";

/**
 * @function MasterDocListReducer
 * @param state {object}
 * @param action {object}
 * @returns {object} Redux Store
 * @memberOf Reducers
 */
export function MasterDocListReducer(state, action) {

    if (typeof state === 'undefined') {
        return {
          requirementsSelectCascade: {
            sectionsTree: [],
            level1Requirements: [],
            level2Requirements: [],
            level3Requirements: [],
            level1RequirementId: null,
            level2RequirementId: null,
            level3RequirementId: null,
          },
          frameworkDetails: {},
          masterDocList: {},
          masterDocListGrid: {
            ...GridReducer(),
            filter: {
              ...GridFilterReducer(),
              path: IDS.masterDocListGrid,
              loc_uuid: null,
              requirement_id: null,
              searched_column: "name",
              doc_type: "all",
              assessment_status: "app",
            },
          },
          masterDocListRequirementsGrid: {
             ...GridReducer(),
          },
          masterDocListDetails: {
            document_type: "pol", // in page add document, first item in drop down menu for document type is Policy
            filePath: null,
            docId: null,
          },
          masterDocListExport: {
            assessmentStatus: "app",
          },
          // gridFilterDocumentTypes: [
          //   { value: "all", label: "All" },
          //   { value: "gdo", label: "Generic" },
          //   { value: "pol", label: "Policy" },
          //   { value: "pro", label: "Procedure" },
          //   { value: "for", label: "Form" },
          //   { value: "che", label: "Checklist" },
          // ],
          exportAssessmentStates: [
            { value: "app", label: "Only Approved Documents" },
            { value: "all", label: "All Documents" },
          ],
          searchedColumns: [
            { value: "name", label: "Document Name" },
            { value: "number", label: "Document Number" },
            { value: "filename", label: "Document Filename" },
          ],
          assessmentStatuses: [
            { value: "app", label: "Approved" },
            { value: "nap", label: "Not Approved" },
            // { value: "pen", label: "Not Scheduled" },
            // { value: 'sch', label: 'Pending Review'},
            // { value: "pro", label: "Under Review" },
            // { value: "sub", label: "Pending Approval" },
            // { value: "ack", label: "Under Approval" },
            { value: "all", label: "All" },
          ],
        };
    }

    switch (action.type) {
        case TYPES.DOCUMENT_SAMPLE_DOC_CHANGED:
            if (action.id === IDS.masterDocList) {
                state = set({...state}, `${action.path}.templateFilename`, getDocFileNameFromPath(action.template));
                return set(state, `${action.path}.template`, action.template);
            }
        case 'LOCATION_SELECTED':
            if(action.id === IDS.masterDocList) { // select-cascade
                state = {...state};
                switch(action.path) {
                    case IDS.masterDocListDetails:
                        return set(state, `${action.path}.loc_uuid`, action.uuid);

                    case IDS.masterDocListGrid:
                        set(state, action.path, GridReducer(state[action.path], set(action, 'type', 'PAGINATE')));
                        return set(state, `${action.path}.filter.loc_uuid`, action.uuid);
                    case IDS.masterDocListExport:
                        set(state, `${action.path}.slo_uuid`, action.type_code === 'slo' ? action.uuid : null);
                        set(state, `${action.path}.slo_name`, action.type_code === 'slo' ? action.locationName : null);
                        return state;
                }
            }
        case TYPES.REQUIREMENT_DETAILS_REFRESH:
            if (action.id === IDS.masterDocList) {
                return {...state, selectedRequirement: action.data};
            }
        case TYPES.SCHEME_DETAILS_REFRESH:
            if (action.id === IDS.masterDocList) {
                return {...state, frameworkDetails: action.data}
            }
        case TYPES.DOC_DETAILS_REFRESH:
            return {
              ...state,
              masterDocListDetails: action.data,
              masterDocListRequirementsGrid: {
                ...GridReducer(),
                items: action.data.requirementsRaw.map((item, index) => ({
                  ...item,
                  id: index + 1,
                })),
              },
            };

        case TYPES.SELECT_REQUIREMENTS_SELECT_CASCADE:
            if (action.id === IDS.masterDocList) {
                state = {...state};
                if(action.schemeCode)
                    set(state,'selectedRequirement.schemeCode', action.schemeCode);
                if (action.level < 3) {
                    set(
                      state,
                      `requirementsSelectCascade.level${action.level + 1}Requirements`,
                      action.sections.map((item) => ({
                        value: item.id,
                        label: item.name,
                      })),
                    );
                }
                if (action.level === 1) {
                    set(state,
                        `requirementsSelectCascade.level3Requirements`,
                        action.level3Requirements.length === 0 ? [{value:0,label:''}]: action.level3Requirements.map(item => ({
                            value: item.id,
                            label: item.name,
                        }))
                    )
                }
                // remove reset value -1 which is avoiding drop down menu automatically pick first item
                if(state.requirementsSelectCascade.level1RequirementId === -1)
                    state = set(state, 'requirementsSelectCascade.level1RequirementId', null);
                if(state.requirementsSelectCascade.level2RequirementId === -1)
                    state = set(state, 'requirementsSelectCascade.level2RequirementId', null);
                if(state.requirementsSelectCascade.level3RequirementId === -1)
                    state = set(state, 'requirementsSelectCascade.level3RequirementId', null);

                return set(state, `requirementsSelectCascade.level${action.level}RequirementId`, action.sectionId);
            }
        case TYPES.RESET_REQUIREMENTS_SELECT_CASCADE:
            if (action.id === IDS.masterDocList) {
                return {
                    ...state,
                    selectedRequirement: null,
                    requirementsSelectCascade: {
                        ...state.requirementsSelectCascade,
                        level1RequirementId: -1,
                        level2RequirementId: -1,
                        level3RequirementId: -1,
                    }
                }
            }
        case GRID.GRID_INIT:
        case GRID.GRID_FILTER:
        case GRID.GRID_FILTER_TOGGLE:
        case GRID.GRID_RESET_FILTER:
        case GRID.GRID_INIT_FILTER:
        case GRID.GRID_LOADING:
        case GRID.GRID_PAGINATE:
        case GRID.GRID_RELOAD:
        case GRID.GRID_FETCH:
        case GRID.GRID_SELECT:
        case GRID.GRID_SELECT_ALL:
        case GRID.GRID_DESELECT:
        case GRID.GRID_DESELECT_ALL:
            if(action.id === IDS.masterDocList) {
                state = set({...state}, action.path, GridReducer(get(state, action.path), action));
                return state;
            }
        case FORM.INPUT_SELECT:
            if (action.id === IDS.masterDocList) {
                state = {...state};
                const component = action.path.split('.')[0];
                switch(component) {
                    case IDS.masterDocListGrid:
                        set (state, 'masterDocListDetails.documentName', action.item.label);
                        return set( state, component,
                            GridReducer(get(state, component),{
                                type:GRID.GRID_FILTER,
                                filter: {
                                    [action.path.split('.').pop()]: action.input
                                }
                            })
                        )
                    case IDS.masterDocListExport:
                        return set (state, action.path, action.input);
                }
            }
        case FORM.INPUT_TEXT:
        case FORM.INPUT_TEXT_AREA:
        case FORM.INPUT_CHECKBOX:
        case FORM.INPUT_DATE:
        case FORM.INPUT_RADIO:
            if (action.id === IDS.masterDocList) {
                state = set({...state}, action.path, action.input);
                if (action.path.startsWith('masterDocListGrid.filter')) {
                    set(state, 'masterDocListGrid.reload', !get(state, 'masterDocListGrid.reload'))
                }
                return state
            }
        // case 'LOCATION_SELECTED': // slo select-cascade.js
            // if (action.id === IDS.accreditationSettingsHeadOffices) {
            //     return set({...state}, 'headOffices.selectedHeadOfficeUuid', action.uuid)
            // }
            // if(action.id === IDS.masterDocListGrid && action.type_code === 'slo') {
            //     state = set({...state},  `${IDS.assessmentGrid}.selectedLocationUuid`, action.uuid);
            //     if(get(state, `${IDS.masterDocListGrid}.filterOpened`))
            //         state = set(state, `${IDS.assessmentGrid}.filter.slo_uuid`, action.uuid);
            //     return set( state, IDS.masterDocListGrid, GridReducer(get(state, IDS.masterDocListGrid),{ type:GRID.GRID_RELOAD }))
            // }
        default:
            return state;
        }
}
